import { render, staticRenderFns } from "./activatePage.vue?vue&type=template&id=0b2ebc94&scoped=true&"
import script from "./activatePage.vue?vue&type=script&lang=ts&"
export * from "./activatePage.vue?vue&type=script&lang=ts&"
import style0 from "./activatePage.vue?vue&type=style&index=0&id=0b2ebc94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ebc94",
  null
  
)

export default component.exports